/* Program Name: ProtectedRoute.js
 **  Description: a component that uses the react-router Route component with
 **               additional logic to lock the route when nessacary. Also adds
 **               the layout layer around its children.
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-03-17  STT  Initial program
 **********************************************************************************/

/**Standard React hooks import */
import React from 'react'

/**React-Router imports */
import { Route, Redirect } from 'react-router-dom'

/**Context */
import { getSessionCookie } from '../../../Context/SessionContext'

/**ProtectedRoute***************************************************************/
/**this component contains a custom route that check to see if their is a session avalible       */
/**if no session is avaible it means that no user is logged in, sending the user to the login    */
/**this component also wrappers the layout component around any of the children components       */
/**-component    > is holding the component that the route will render */
const ProtectedRoute = ({ component: Component, title, ...rest }) => {
  /*****************************************************************************/
  /**Local Variables */

  /*****************************************************************************/
  /**Rendering */

  return (
    /**takes the prop values from the parent component and passes them into the Route */
    /**renders the component that was passed into the parent *IF* currentUser exsists AKA: authenticated */
    /**if the user is not authenticated it will redirect you to the Login component */
    <Route
      {...rest}
      render={(props) => {
        if (getSessionCookie()) {
          document.title = title + ' ezPOP'
          return <Component {...props} />
        } else {
          return <Redirect to="/login" />
        }
      }}
    ></Route>
  )
}

export default ProtectedRoute
